import React from 'react'
import PropTypes from 'prop-types'
import FormInput from 'components/FormInput'
import {reduxForm, Field, reset} from 'redux-form'
import {addMappingForCategory} from 'redux/modules/settings/actions'

export class AddMappingForm extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool
  }

  static contextTypes = {
    permissions: PropTypes.object
  }

  render() {
    const {handleSubmit, invalid} = this.props
    const {permissions} = this.context
    const hidden = !permissions.show.includes('@features/categoryMappings')

    if (hidden) return null

    return (
      <form className='settings-categories-view_add-form' onSubmit={handleSubmit}>
        <label htmlFor='mapping'>Add new mapping</label>
        <Field name='mapping' component={FormInput} />
        <button type='submit' disabled={invalid}>Add</button>
      </form>
    )
  }
}

export default reduxForm({
  form: 'addMappingForm',
  validate: ({mapping}) => {
    const errors = {}
    if (!mapping) {
      errors._error = 'Mapping name is required'
    }

    return errors
  },
  onSubmit: ({mapping}, dispatch, props) => {
    const {category} = props
    dispatch(addMappingForCategory({category, mapping}))
    dispatch(reset('addMappingForm'))
  }
})(AddMappingForm)



// WEBPACK FOOTER //
// ./client/views/SettingsCategoriesView/AddMappingForm.js